import { useEffect } from 'react';

export default function Benefits() {
  useEffect(() => {
    document.title = 'Partner Benefits - KiloBeaters';
  }, []);

  return (
    <div className="w-full min-h-screen flex flex-col">
      <iframe
        src="https://umkcbnk2-82esgbfp.manus.space"
        title="KiloBeaters Partner Program Benefits"
        className="w-full flex-1 border-0"
        style={{ minHeight: 'calc(100vh - 120px)' }}
        allowFullScreen
      />
      <footer
        className="w-full border-t bg-white px-6 py-5 flex flex-col sm:flex-row items-center justify-center gap-6"
        data-testid="benefits-downloads"
      >
        <div className="flex items-center gap-3">
          <span className="text-sm font-medium text-gray-700">India:</span>
          <a
            href="/docs/kilobeaters-partner-program-india.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm font-medium text-orange-600 hover:text-orange-700 underline underline-offset-4 decoration-orange-300 hover:decoration-orange-500"
            data-testid="benefits-download-india"
          >
            Click here to know more →
          </a>
        </div>
        <span className="hidden sm:inline text-gray-300">•</span>
        <div className="flex items-center gap-3">
          <span className="text-sm font-medium text-gray-700">Dubai:</span>
          <a
            href="/docs/kilobeaters-partner-program-dubai.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm font-medium text-orange-600 hover:text-orange-700 underline underline-offset-4 decoration-orange-300 hover:decoration-orange-500"
            data-testid="benefits-download-dubai"
          >
            Click here to know more →
          </a>
        </div>
      </footer>
    </div>
  );
}
